import React from 'react'
import Papa from 'papaparse'
import styled from 'styled-components'

import { LinkButton } from '../buttons/Buttons'
import { translate } from '../../utils/translation'
import { fonts, palette } from '../../styles/variables'
import { Text } from '../topography'
import Icon from '../icon/Icon'
import uploadIcon from '../../styles/assets/upload_icon.svg'
import deleteIcon from '../../styles/assets/delete_icon.svg'

import FileInput from './FileInput'

const InputWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: palette.lightGray10,
  border: `1px solid ${palette.lightGray}`,
  boxSizing: 'border-box',
  borderRadius: '2px',
  padding: '12px 16px',
})
export default class CSVInput extends React.Component {
  constructor(props) {
    super(props)
    this.input = React.createRef()

    this.state = {
      file: '',
      parsedKeywords: [],
      invalidCSV: false,
    }
  }

  setRef = (ref) => {
    this.input = ref
  }

  processCSV = (file, onComplete) => {
    this.setState({ file: file.name })
    if (window.FileReader) {
      const reader = new FileReader()
      reader.readAsText(file)
      reader.onload = () => {
        const text = reader.result
        const result = Papa.parse(text)
        onComplete(result.data)
      }
      reader.onerror = () => null
    }
  }

  render() {
    const { file, parsedKeywords, invalidCSV } = this.state
    const { onRemove, onAdd, testId } = this.props
    const buttonIcon = file ? deleteIcon : uploadIcon
    const buttonText = file ? translate('delete') : translate('upload_button')
    return (
      <>
        <InputWrapper data-testid={testId || ''}>
          <Text
            lineHeight="16px"
            color={file ? palette.darkGray : palette.lightGray}
          >
            {file ? this.input.files[0].name : translate('no_file_uploaded')}
          </Text>
          <LinkButton
            onClick={() => {
              if (file) {
                onRemove(parsedKeywords)
                this.setState({ file: '', parsedKeywords: [] })
                this.input.value = ''
              } else {
                this.input.click()
              }
              this.setState({ invalidCSV: false })
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '14px',
              lineHeight: '16px',
              color: palette.darkGray,
              fontFamily: fonts.primaryBook,
            }}
          >
            <Icon src={buttonIcon} margin="0 8px 0 0" />
            {buttonText}
          </LinkButton>
          <FileInput
            accept=".csv"
            forwardRef={this.setRef}
            onChange={(event) => {
              if (event.target.files[0].name.indexOf('.csv') > -1) {
                this.processCSV(event.target.files[0], (data) => {
                  this.setState({ parsedKeywords: data })
                  onAdd(data)
                })
              } else {
                this.setState({ invalidCSV: true })
              }
            }}
          />
        </InputWrapper>
        <Text
          fontSize="12px"
          lineHeight="14px"
          margin="12px 0 24px 0"
          color={palette.gray}
          boldColor={palette.gray}
          dangerouslySetInnerHTML={{
            __html: (() => {
              if (!file) return translate('files_supported')
              if (invalidCSV) return translate('invalid_upload')
              return translate('keywords_recognized', parsedKeywords.length)
            })(),
          }}
        />
      </>
    )
  }
}
